export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_11.fb63f7e6.jpg";